module.exports = (__webpack_require__(70548))(47834);